//import $ from 'jquery';
import { Fancybox } from "@fancyapps/ui";
//import 'slick-carousel';
import Splide from '@splidejs/splide';
import '../js/app.jobsearch.js';

/* ==========================================================================
   Debounce
   ========================================================================== */

function debounce(callback, wait) {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    let observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    let items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer");
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

const navButton = document.querySelector(".js-trigger-mobile-nav");
const navElement = document.querySelector(".main-nav");

navButton.addEventListener("click", function () {
    navElement.classList.toggle("is-active");
    this.classList.toggle("is-active");
});

/* ==========================================================================
   Sub nav toggle
   ========================================================================== */

var subNavButtonEls = document.querySelectorAll(".js-trigger-subnav");
var activeSubNavEls = document.querySelectorAll(".sub-nav")
for (var i = 0; i < subNavButtonEls.length; i++) {
    subNavButtonEls[i].addEventListener("click", function (e) {
        e.preventDefault();
        this.parentElement.parentElement.querySelector(".sub-nav").classList.toggle("is-active");
        this.classList.toggle("is-active");
    });
}

/* ==========================================================================
   Search form
   ========================================================================== */

if (document.querySelector(".js-toggle-search")) {
    var isSearchActive = false;

    document.querySelector(".js-toggle-search").addEventListener("click", function (e) {
        if (isSearchActive) {
            this.parentElement.classList.remove("is-active");
            isSearchActive = false;
        } else {
            this.parentElement.classList.add("is-active");
            document.querySelector(".header-search-widget__input").focus();
            isSearchActive = true;
        }
    });
}

/* ==========================================================================
   Search Results
   ========================================================================== */

if ($('.js-search-results').length) {

    $(document).on('keyup', '.js-search-term', debounce(() => { search() }, 300));
    $(document).on('change', '.js-search-category', function () { search() });
    $(document).on('click', '.js-search-results .js-pagination-link', function () { search($(this).data('page')) });

    function search(page = 1) {
        $.ajax({
            url: '/umbraco/surface/Search/GetResults',
            type: 'GET',
            data: {
                culture: document.documentElement.lang,
                recipes: $('#recipes').prop('checked'),
                products: $('#products').prop('checked'),
                tips: $('#tips').prop('checked'),
                articles: $('#articles').prop('checked'),
                search: $('.js-search-term').val(),
                page: page,
                resultsPerPage: $('.js-search-results').data('resultsperpage')
            },
            success: function (response) {
                $('.js-search-results').html(response);
            }
        });
    }
}

/* ==========================================================================
   Products Results
   ========================================================================== */

if ($('.js-products-results').length) {

    $(document).on('change', '.js-products-filter', () => loadProducts());
    $(document).on('click', '.js-products-results .js-pagination-link', function () { loadProducts($(this).data('page')) });
    $(document).on('click', '.js-products-tag', function (e) {
        e.preventDefault();
        $('.js-products-tag').removeClass('is-active');
        $(this).addClass('is-active');
        loadProducts();
    });

    function loadProducts(page = 1) {
        let category = $('#ProductCategory').val();
        let tag = $('.js-products-tag.is-active').data('tag');

        let url = new URL(window.location);
        url.searchParams.set('category', category);
        url.searchParams.set('tag', tag);
        url.searchParams.set('page', page);
        window.history.pushState({}, '', url);

        $.ajax({
            url: '/umbraco/surface/Products/GetResults',
            type: 'GET',
            traditional: true,
            data: {
                category: category,
                tag: tag,
                culture: document.documentElement.lang,
                page: page,
                resultsPerPage: $('.js-products-results').data('resultsperpage'),
            },
            success: function (response) {
                $('.js-products-results').html(response);
            }
        });
    }
}

/* ==========================================================================
   Recipes Results
   ========================================================================== */

if ($('.js-recipes-results').length) {

    $(document).on('keyup', '.js-recipes-search-term', debounce(() => { loadRecipes() }, 300));
    $(document).on('change', '.js-recipes-filter', () => loadRecipes());
    $(document).on('click', '.js-recipes-results .js-pagination-link', function () { loadRecipes($(this).data('page')) });

    function loadRecipes(page = 1) {
        let product = $('#Product').val();
        let category = $('#Category').val();
        let dietary = $('#Dietary').val();
        let cooktime = $('#CookTime').val();
        let search = $('.js-recipes-search-term').val();

        let url = new URL(window.location);
        url.searchParams.set('product', product);
        url.searchParams.set('category', category);
        url.searchParams.set('dietary', dietary);
        url.searchParams.set('cooktime', cooktime);
        url.searchParams.set('search', search);
        url.searchParams.set('page', page);
        window.history.pushState({}, '', url);

        $.ajax({
            url: '/umbraco/surface/Recipes/GetResults',
            type: 'GET',
            traditional: true,
            data: {
                product: product,
                category: category,
                dietary: dietary,
                cookTime: cooktime,
                culture: document.documentElement.lang,
                search: search,
                page: page,
                resultsPerPage: $('.js-recipes-results').data('resultsperpage'),
            },
            success: function (response) {
                $('.js-recipes-results').html(response);
            }
        });
    }
}

/* ==========================================================================
   Recipe Ingredients Servings
   ========================================================================== */

$(document).on('change', '#Servings', function () {
    $('.recipe-ingredients ul li[data-serving]').hide();
    $('.recipe-ingredients ul li[data-serving=' + $(this).val() + ']').show();
});

/* ==========================================================================
   Splide Slider/Carousel
   ========================================================================== */

let heroBannerSlider = document.querySelectorAll('.js-splide-hero-banner');
if (heroBannerSlider.length) {
    for (let i = 0; i < heroBannerSlider.length; i++) {
        let splideElement = heroBannerSlider[i];
        let splideDefaultOptions = {
            type: 'fade',
            perPage: 1,
            perMove: 1,
            lazyLoad: 'nearby',
            arrows: false,
            pagination: true,
            arrowPath: 'M31.5,20c0,.7-.4,1.4-.9,2l-17.2,17.2c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1l15.1-15.1L9.3,4.9c-1.1-1.1-1.1-3,0-4.1,1.1-1.1,3-1.1,4.1,0l17.2,17.2c.5.5.9,1.2.9,2Z',
        }
        let splide = new Splide(splideElement, splideDefaultOptions);
        splide.mount();
    }
}


let featureRecipesSlider = document.querySelectorAll('.js-splide-feature-recipes');
if (featureRecipesSlider.length) {
    for (let i = 0; i < featureRecipesSlider.length; i++) {
        let splideElement = featureRecipesSlider[i];
        let splideDefaultOptions = {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            gap: '30px',
            lazyLoad: 'nearby',
            arrows: false,
            pagination: false,
            arrowPath: 'M31.5,20c0,.7-.4,1.4-.9,2l-17.2,17.2c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1l15.1-15.1L9.3,4.9c-1.1-1.1-1.1-3,0-4.1,1.1-1.1,3-1.1,4.1,0l17.2,17.2c.5.5.9,1.2.9,2Z',
            breakpoints: {
                1024: {
                    perPage: 3,
                    padding: { left: '0', right: '100px' },
                    arrows: false,
                    pagination: true
                },
                768: {
                    perPage: 2,
                    padding: { left: '0', right: '100px' },
                    arrows: false,
                    pagination: true
                },
                600: {
                    perPage: 1,
                    padding: { left: '0', right: '50px' },
                    gap: '20px',
                    arrows: false,
                    pagination: true
                },
            },
        }
        let splide = new Splide(splideElement, splideDefaultOptions);
        splide.mount();
    }
}

let featureProductsSlider = document.querySelectorAll('.js-splide-feature-products');
if (featureProductsSlider.length) {
    for (let i = 0; i < featureProductsSlider.length; i++) {
        let splideElement = featureProductsSlider[i];
        let splideDefaultOptions = {
            type: 'slide',
            perPage: 6,
            perMove: 1,
            gap: '30px',
            lazyLoad: 'nearby',
            arrows: false,
            pagination: false,
            arrowPath: 'M31.5,20c0,.7-.4,1.4-.9,2l-17.2,17.2c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1l15.1-15.1L9.3,4.9c-1.1-1.1-1.1-3,0-4.1,1.1-1.1,3-1.1,4.1,0l17.2,17.2c.5.5.9,1.2.9,2Z',
            breakpoints: {
                1024: {
                    perPage: 4,
                    padding: { left: '0', right: '100px' },
                    arrows: false,
                    pagination: true
                },
                768: {
                    perPage: 3,
                    padding: { left: '0', right: '100px' },
                    arrows: false,
                    pagination: true
                },
                600: {
                    perPage: 2,
                    padding: { left: '0', right: '50px' },
                    gap: '20px',
                    arrows: false,
                    pagination: true
                },
            },
        }
        let splide = new Splide(splideElement, splideDefaultOptions);
        splide.mount();
    }
}

var relatedRecipesSlider = document.querySelectorAll('.js-splide-related-recipes');
if (relatedRecipesSlider.length) {
    for (var i = 0; i < relatedRecipesSlider.length; i++) {
        var splideElement = relatedRecipesSlider[i];
        var splideDefaultOptions = {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '30px',
            lazyLoad: 'nearby',
            arrows: false,
            pagination: false,
            arrowPath: 'M31.5,20c0,.7-.4,1.4-.9,2l-17.2,17.2c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1l15.1-15.1L9.3,4.9c-1.1-1.1-1.1-3,0-4.1,1.1-1.1,3-1.1,4.1,0l17.2,17.2c.5.5.9,1.2.9,2Z',
            breakpoints: {
                768: {
                    perPage: 2,
                    padding: { left: '0', right: '100px' },
                    arrows: false,
                    pagination: true
                },
                600: {
                    perPage: 1,
                    padding: { left: '0', right: '50px' },
                    gap: '20px',
                    arrows: false,
                    pagination: true
                },
            },
        }
        var splide = new Splide(splideElement, splideDefaultOptions);
        splide.mount();
    }
}

var relatedProductsSlider = document.querySelectorAll('.js-splide-related-products');
if (relatedProductsSlider.length) {
    for (var i = 0; i < relatedProductsSlider.length; i++) {
        var splideElement = relatedProductsSlider[i];
        var splideDefaultOptions = {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '80px',
            lazyLoad: 'nearby',
            arrows: false,
            pagination: false,
            arrowPath: 'M31.5,20c0,.7-.4,1.4-.9,2l-17.2,17.2c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1l15.1-15.1L9.3,4.9c-1.1-1.1-1.1-3,0-4.1,1.1-1.1,3-1.1,4.1,0l17.2,17.2c.5.5.9,1.2.9,2Z',
            breakpoints: {
                768: {
                    perPage: 2,
                    padding: { left: '0', right: '100px' },
                    gap: '40px',
                    arrows: false,
                    pagination: true
                },
                600: {
                    perPage: 1,
                    padding: { left: '0', right: '50px' },
                    gap: '20px',
                    arrows: false,
                    pagination: true
                },
            },
        }
        var splide = new Splide(splideElement, splideDefaultOptions);
        splide.mount();
    }
}

/* ==========================================================================
   Dynamic Star Rating Submission
   ========================================================================== */

const starRatingElements = document.querySelectorAll('.js-star-rating');

for (const ratingElement of starRatingElements) {
    const radios = ratingElement.querySelectorAll('input[type="radio"][name="rating"]');
    const contentId = ratingElement.getAttribute('data-content-id');

    if (!contentId || isNaN(contentId)) continue;

    for (const radio of radios) {
        radio.addEventListener('change', function () {
            const selectedValue = this.value;

            let ratingValue = 0;
            switch (selectedValue) {
                case "5": ratingValue = 5; break;
                case "4.5": ratingValue = 4.5; break;
                case "4": ratingValue = 4; break;
                case "3.5": ratingValue = 3.5; break;
                case "3": ratingValue = 3; break;
                case "2.5": ratingValue = 2.5; break;
                case "2": ratingValue = 2; break;
                case "1.5": ratingValue = 1.5; break;
                case "1": ratingValue = 1; break;
                case "0.5": ratingValue = 0.5; break;
                default: return;
            }

            const payload = {
                rating: ratingValue,
                contentId: parseInt(contentId)
            };

            fetch("/umbraco/surface/Rating/SubmitRating", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            })
                .then(async response => {
                    if (!response.ok) {
                        const errorText = await response.text();
                        console.error("Server returned error response text:", errorText);
                        throw new Error(`HTTP ${response.status}: ${errorText}`);
                    }
                    const data = await response.json();

                    // Show success message
                    const messageDiv = ratingElement.querySelector('.js-rating-message');
                    if (messageDiv) {
                        messageDiv.textContent = "Your Rating Has Been Saved!!!";
                        messageDiv.style.display = "block";
                        messageDiv.style.opacity = 0;
                        messageDiv.style.transition = "opacity 0.5s";

                        // Fade in
                        requestAnimationFrame(() => {
                            messageDiv.style.opacity = 1;
                        });

                        // Fade out after 2.5 seconds
                        setTimeout(() => {
                            messageDiv.style.opacity = 0;
                            // After fade out, hide it completely
                            setTimeout(() => {
                                messageDiv.style.display = "none";
                            }, 1000); // match transition duration
                        }, 2500);
                    }

                    return data;
                })

                .catch(error => {
                    console.error("Error submitting rating:", error);
                });
        });
    }
}

/* ==========================================================================
   Filter Accordions by Selected Tag
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.accordion-filters .button');
    const accordions = document.querySelectorAll('.accordion__details');

    const urlParams = new URLSearchParams(window.location.search);
    const activeTagFromUrl = urlParams.get('tag') || '';
    let currentActiveTag = activeTagFromUrl;

    function getUrlSegmentFromButton(button) {
        const href = button.getAttribute('href');
        return href?.includes('tag=') ? href.split('tag=')[1] : '';
    }

    function updateURL(urlSegment) {
        const url = new URL(window.location);
        if (urlSegment) {
            url.searchParams.set('tag', urlSegment);
        } else {
            url.searchParams.delete('tag');
        }
        window.history.pushState({}, '', url);
    }

    function filterAccordions(urlSegment) {
        const lowerSegment = urlSegment.toLowerCase();

        // Update button active states
        buttons.forEach(btn => {
            const btnSegment = getUrlSegmentFromButton(btn).toLowerCase();
            if (btnSegment === lowerSegment) {
                btn.classList.add('is-active');
            } else {
                btn.classList.remove('is-active');
            }
        });

        // Show/hide accordions
        accordions.forEach(detail => {
            const tags = (detail.dataset.tags || '').split(',').map(t => t.trim().toLowerCase());
            detail.style.display = tags.includes(lowerSegment) || !urlSegment ? '' : 'none';
        });

        updateURL(urlSegment);
        currentActiveTag = urlSegment;
    }

    // Handle toggle logic
    buttons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            // Remove focus for visual fix
            this.blur();

            const clickedTag = getUrlSegmentFromButton(this);

            if (currentActiveTag === clickedTag) {
                this.classList.remove('is-active');
                requestAnimationFrame(() => {
                    filterAccordions('');
                });
            } else {
                filterAccordions(clickedTag);
            }
        });
    });

    // On load, set initial state
    if (activeTagFromUrl) {
        filterAccordions(activeTagFromUrl);
    }
});

/* ==========================================================================
   Fancybox Popups
   ========================================================================== */

Fancybox.bind('[data-fancybox]', {
    // Custom options for all galleries
});

/* ==========================================================================
   Client Side Filtering for Team Members by Category
   ========================================================================== */
const teamFilter = document.getElementById('team-filter');

if (teamFilter) {
    teamFilter.addEventListener('change', function () {
        const selected = this.value;
        document.querySelectorAll('.block-team__grid-item').forEach(item => {
            const category = item.getAttribute('data-category');
            item.style.display = (!selected || category === selected) ? '' : 'none';
        });
    });
}

/* ==========================================================================
   Client Side Filtering for Accordion FAQ by Category
   ========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
    const filterDropdown = document.getElementById("accordion-filter");
    const accordions = document.querySelectorAll(".accordion__details");

    if (filterDropdown) {
        filterDropdown.addEventListener("change", function () {
            const selectedCategory = this.value.toLowerCase();

            accordions.forEach((item) => {
                const tags = item.dataset.tags?.split(",") || [];

                if (!selectedCategory || tags.includes(selectedCategory)) {
                    item.style.display = "";
                } else {
                    item.style.display = "none";
                }
            });
        });
    }
});
